module.exports = __webpack_public_path__ + "static/media/conor.28c2f40f.jpg";